// Originea backend-ului (fără sufixul /api). Fișierele statice — imagini, video,
// PDF-uri, uploads — sunt servite de backend la root (/uploads/...), nu sub /api.
// REACT_APP_API_URL include /api, deci îl tăiem ca să obținem originea.
export const apiOrigin = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  return apiUrl.replace(/\/api\/?$/, '');
};
